// Tipo de credor (users.creditor_type) e o documento de identificação esperado de cada um.
export const CREDITOR_PROFILE = { PERSON: 1, COMPANY: 2, ESTATE: 3, HEIR: 4 };

const data = [
    {
        id: CREDITOR_PROFILE.PERSON,
        name: 'Pessoa física',
        registration: 'cpf',
        nameLabel: 'Nome completo',
        documentLabel: 'Documento de identificação (RG, CNH ou CPF)'
    },
    {
        id: CREDITOR_PROFILE.COMPANY,
        name: 'Pessoa jurídica',
        registration: 'cnpj',
        nameLabel: 'Razão social',
        documentLabel: 'Contrato social ou estatuto'
    },
    {
        id: CREDITOR_PROFILE.ESTATE,
        name: 'Espólio (representado por inventariante)',
        registration: 'cpf',
        nameLabel: 'Nome do falecido (espólio)',
        documentLabel: 'Certidão de óbito ou documento do falecido'
    },
    {
        id: CREDITOR_PROFILE.HEIR,
        name: 'Herdeiro',
        registration: 'cpf',
        nameLabel: 'Nome completo',
        documentLabel: 'Documento de identificação (RG, CNH ou CPF)'
    }
];

export const getCreditorProfile = (id) => data.find((item) => item.id === Number(id)) || null;

export default [...data];
